"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutAaEaglePlumbing() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const differentiators = ["24/7 Emergency Service Available", "Licensed & Insured Technicians", "Upfront Transparent Pricing", "Same-Day Service Guarantee"];
  return <section id="about-aa-eagle-plumbing" className="relative min-h-screen bg-background overflow-hidden">
      <div className="grid lg:grid-cols-2 min-h-screen">
        {}
        <div className="relative h-[50vh] lg:h-screen overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-out" style={{
          backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/technician_professional_portrait.png)",
          transform: isVisible ? "scale(1.05)" : "scale(1)",
          filter: "hue-rotate(-10deg) saturate(1.1) brightness(0.95)"
        }} />
        </div>

        {}
        <div ref={ref} className="flex flex-col justify-center px-8 py-16 lg:px-16 lg:py-24 bg-background" style={{
        opacity: isVisible ? 1 : 0,
        transition: "opacity 200ms ease-out"
      }}>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-[hsl(220,80%,45%)] mb-6">
            About AA Eagle Plumbing
          </h2>

          <p className="text-foreground text-lg leading-relaxed mb-8 max-w-xl">
            We are a family-owned plumbing company dedicated to providing exceptional service
            to our community. With over 20 years of experience, our expert technicians deliver
            reliable solutions for all your plumbing needs.
          </p>

          <ul className="space-y-4">
            {differentiators.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3 group" style={{
            animation: isVisible ? `fade-in-up var(--duration-slow) var(--ease-smooth) forwards ${i * 100}ms` : "none"
          }}>
                <span className="flex-shrink-0 w-2 h-2 rounded-full mt-2 transition-all duration-300" style={{
              backgroundColor: "hsl(170, 75%, 55%)",
              animation: isVisible ? "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite" : "none",
              animationDelay: `${i * 150}ms`
            }} />
                <span className="text-foreground text-base font-medium">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.3);
          }
        }
      `}</style>
    </section>;
}